import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type {
  WalletTopUpApprovePayload,
  WalletTopUpRejectPayload,
  WalletTopUpCreateResponse,
  WalletTopUpFilters,
  WalletTopUpPayload,
  WalletTopUpResponse,
} from "../types/wallet-request.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.walletTopup;

export const walletTopupService = {
  async list(filter: WalletTopUpFilters): Promise<WalletTopUpResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<WalletTopUpResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to load wallet top-up requests due to an unexpected error.",
        data: {},
        resData: null,
      } as unknown as WalletTopUpResponse;
    }
  },

  async create(payload: WalletTopUpPayload): Promise<WalletTopUpCreateResponse> {
    try {
      return await apiClient<WalletTopUpCreateResponse>(endpoints.create, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to create wallet top-up request due to an unexpected error.",
        resData: null,
      };
    }
  },

  async approve(requestRef: string, payload: WalletTopUpApprovePayload): Promise<WalletTopUpCreateResponse> {
    try {
      return await apiClient<WalletTopUpCreateResponse>(endpoints.approve(requestRef), {
        method: "PUT",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to approve wallet top-up request due to an unexpected error.",
        resData: null,
      };
    }
  },

  async reject(requestRef: string, payload: WalletTopUpRejectPayload): Promise<WalletTopUpCreateResponse> {
    try {
      return await apiClient<WalletTopUpCreateResponse>(endpoints.reject(requestRef), {
        method: "PUT",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to reject wallet top-up request due to an unexpected error.",
        resData: null,
      };
    }
  },
};
